import React from 'react';
import { programs } from '../../data/programs';
import { site, socials } from '../../data/site';
import { Container } from '../ui/Container';
import { SocialIcon } from '../ui/SocialIcon';
const headingClass = 'text-sm font-semibold uppercase tracking-[0.12em] text-white/55';
const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-white/80 transition-colors duration-150 hover:text-white';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-black text-white" data-id="element-284" data-mp="3s25c0bcfdhhh">
      <Container className="grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8" data-id="element-285" data-mp="3s1c9jmki1e55">
        <div className="sm:col-span-2 lg:col-span-4" data-id="element-286" data-mp="3n43vny6dvw9p">
          <a href="#top" className="inline-flex items-center gap-4" data-id="element-287" data-mp="3j2iisctunhzi">
            <img src={site.logo} alt="" className="h-24 w-auto" loading="lazy" data-id="element-288" data-mp="3j05ttfpoc7cy" />
            <span className="font-display text-[1.75rem] font-bold uppercase leading-[0.95] tracking-wide" data-id="element-289" data-mp="3e248eo4rzvyb">
              Bates
              <br data-id="element-290" data-mp="2kd4oiylnlqef" />
              Taekwondo
            </span>
          </a>
          <p className="mt-5 max-w-[22rem] text-[15px] leading-relaxed text-white/70" data-id="element-291" data-mp="2kb08xjee72yb">
            Family-owned and operated since 2015. Olympic-style Taekwondo for ages 3 through adult in Albuquerque.
          </p>
        </div>

        <div className="lg:col-span-3" data-id="element-292" data-mp="2gb9m1qrzl6z2">
          <h2 className={headingClass} data-id="element-293" data-mp="2gcb0844au9l0">Visit &amp; contact</h2>
          <address className="mt-4 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-294" data-mp="340kg6peu0348">
            {site.street}
            <br data-id="element-295" data-mp="382yvx0n7emra" />
            {site.cityLine}
          </address>
          <ul className="mt-2" data-id="element-296" data-mp="2u2wj3str6jiw">
            <li data-id="element-297" data-mp="2u3plyiplcovr">
              <a href={site.directionsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-298" data-mp="2u24oak7zcpto">
                Get directions<span className="sr-only" data-id="element-299" data-mp="2z43sfwbjnqro"> (opens in a new tab)</span>
              </a>
            </li>
            <li data-id="element-300" data-mp="1ipu617qv4c3h">
              <a href={site.phoneHref} className={linkClass} data-id="element-301" data-mp="1nmuc3inppeul">
                {site.phoneDisplay}
              </a>
            </li>
            <li data-id="element-302" data-mp="13kzgkrw4vczj">
              <a href={site.emailHref} className={linkClass} data-id="element-303" data-mp="13jg0p2ee33ya">
                {site.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2" data-id="element-304" data-mp="us5xejdkftge">
          <h2 className={headingClass} data-id="element-305" data-mp="ur4ksagwiywk">Programs</h2>
          <ul className="mt-3" data-id="element-306" data-mp="ptch6j6w9ocj">
            {programs.map(p => <li key={p.id} data-id="element-307" data-mp="pt2t515etr9h">
                <a href={`#program-${p.id}`} className={linkClass} data-id="element-308" data-mp="ku877qc5bml5">
                  {p.name}
                </a>
              </li>)}
            <li data-id="element-309" data-mp="fudls2b53p7h">
              <a href="#first-class" className={linkClass} data-id="element-310" data-mp="ftu1iey0ooqa">
                Free trial class
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3" data-id="element-311" data-mp="6v8laqg0plso">
          <h2 className={headingClass} data-id="element-312" data-mp="6wbbsx9fhm82">Follow Bates</h2>
          <ul className="mt-3" data-id="element-313" data-mp="267ukrbuqeuhq">
            {socials.map(s => <li key={s.name} data-id="element-314" data-mp="218hz2ufljtgq">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-315" data-mp="2188936ujxmb1">
                  <SocialIcon name={s.name} className="h-[18px] w-[18px]" data-id="element-316" data-mp="28qze1g68s0h3" />
                  {s.label}
                  <span className="sr-only" data-id="element-317" data-mp="2dpsr57hm9pgq"> (opens in a new tab)</span>
                </a>
              </li>)}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10" data-id="element-318" data-mp="2ngnb257e4cz0">
        <Container className="flex flex-col gap-2 py-6 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-319" data-mp="2ngdj4c2sbvqo">
          <p data-id="element-320" data-mp="1pv98xk30inyz">© {year} Bates Taekwondo. All rights reserved.</p>
          <p data-id="element-321" data-mp="1utaovw556768">
            {site.street}, {site.cityLine}
          </p>
        </Container>
      </div>
    </footer>;
}